import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function PricingOffer() {
  return <section className="py-12 md:py-20 px-4 bg-cream-100 relative overflow-hidden" id="cart" data-id="element-106">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-cream-200 via-cream-100 to-cream-100" data-id="element-107"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border border-gold-500/20 p-6 md:p-10 text-center" data-id="element-109">
          <div className="inline-block bg-danger text-white font-bold px-6 py-2 rounded-full text-lg mb-6 animate-bounce shadow-lg" data-id="element-110">
            -53% OFF HOY
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-espresso-900 mb-4" data-id="element-111">
            Comienza tu viaje como <em data-id="element-112">barista</em> en casa
          </h2>

          <p className="text-xl text-espresso-700 mb-8 max-w-2xl mx-auto" data-id="element-113">
            Obtén <strong data-id="element-114">acceso inmediato</strong> a "El Arte del Café" + los{' '}
            <u className="decoration-gold-500 decoration-2 underline-offset-4" data-id="element-115">
              10 bonos exclusivos.
            </u>
          </p>

          <div className="bg-cream-200/50 rounded-2xl p-6 mb-8 max-w-md mx-auto border border-espresso-900/5" data-id="element-116">
            <p className="text-espresso-800 font-medium mb-1 uppercase tracking-wider text-sm" data-id="element-117">
              Pago Único. <strong data-id="element-118">Acceso de por vida.</strong>
            </p>
            <div className="flex justify-center" data-id="element-119">
              <PriceDisplay amount={13.97} originalAmount={30} size="xl" data-id="element-120" />
            </div>
          </div>

          <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" onClick={() => window.fbq?.('track', 'AddToCart')} className="w-full md:w-auto inline-flex items-center justify-center gap-3 bg-cta-600 hover:bg-cta-800 text-white text-xl md:text-2xl font-bold py-5 px-12 rounded-xl shadow-[0_8px_30px_rgb(45,106,46,0.3)] hover:shadow-[0_8px_30px_rgb(45,106,46,0.5)] transition-all transform hover:-translate-y-1" data-id="element-121">
            <span className="text-3xl" data-id="element-122"></span> Agregar al carrito
          </a>

          {/* Trust Elements */}
          <div className="mt-8 pt-6 border-t border-espresso-900/10" data-id="element-123">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-espresso-700" data-id="element-124">
              <div className="flex items-center gap-2" data-id="element-125">
                <Lock className="w-5 h-5 text-cta-600" data-id="element-126" />
                <span className="font-medium text-sm" data-id="element-127">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-128">
                <ShieldCheck className="w-5 h-5 text-cta-600" data-id="element-129" />
                <span className="font-medium text-sm" data-id="element-130">Garantía de 30 días</span>
              </div>
            </div>

            <div className="flex justify-center items-center gap-4 mt-4 opacity-60 grayscale" data-id="element-131">
              <div className="font-bold text-xl italic tracking-tighter" data-id="element-132">
                VISA
              </div>
              <div className="font-bold text-xl flex items-center" data-id="element-133">
                <div className="w-6 h-6 rounded-full bg-red-500 mix-blend-multiply" data-id="element-134"></div>
                <div className="w-6 h-6 rounded-full bg-yellow-500 mix-blend-multiply -ml-3" data-id="element-135"></div>
              </div>
              <div className="font-bold text-xl italic text-blue-800" data-id="element-136">
                PayPal
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}